"use client";

import { c as _c } from "react/compiler-runtime";
import { useWaveDrops } from "./useWaveDrops";
const GALLERY_DROPS_LIMIT = 20;
export function useWaveGalleryDrops(waveId) {
  const $ = _c(2);
  let t0;
  if ($[0] !== waveId) {
    t0 = {
      waveId,
      containsMedia: true,
      limit: GALLERY_DROPS_LIMIT
    };
    $[0] = waveId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useWaveDrops(t0);
}